<template>
  <div
    class="min-h-screen max-h-screen overflow-auto w-full flex items-center justify-center p-4 sm:pt-[15rem] lg:pt-[0rem] md:pt-[15rem]"
  >
    <!-- First Step - Phone Input -->
    <div>
      <div
        v-if="cardStep === 1"
        class="flex items-center gap-[15px] w-full max-w-[1200px]"
      >
        <img
          class="hidden lg:block w-[650px] h-[580px] rounded-[10px] flex-shrink-0"
          src="../assets/image/login_page.png"
          alt="login_page_png"
        />
        <div
          class="bg-white w-full max-w-[520px] lg:w-[520px] h-auto lg:h-[580px] rounded-[10px] shadow-lg flex justify-center flex-col"
        >
          <div class="mt-[25px] px-6 sm:px-12 pb-6 flex flex-col">
            <h2
              class="font-bold text-[24px] sm:text-[28px] text-center text-[#5856D6]"
            >
              Snappy!
            </h2>
            <h2
              class="font-bold text-center text-[20px] sm:text-[25px] text-[#090909] mt-2"
            >
              Hush kelibsiz!
            </h2>
            <!--            <span-->
            <!--              class="text-center font-normal text-[14px] sm:text-[17px] leading-[20px] sm:leading-[22px] tracking-[-0.43px] text-[#757575] mt-3 px-2"-->
            <!--            >-->
            <!--              Servisga kirish uchun telefon raqamingizni kiriting-->
            <!--            </span>-->

            <div class="mt-[2rem] flex flex-col gap-[20px] sm:gap-[25px]">
              <!--              <input-->
              <!--                type="tel"-->
              <!--                placeholder="Nomeringizni kiriting"-->
              <!--                v-model="phoneNumber"-->
              <!--                @input="formatPhoneNumber"-->
              <!--                @focus="onFocus"-->
              <!--                @blur="onBlur"-->
              <!--                @keydown="handleKeydown"-->
              <!--                :class="inputBackgroundColor"-->
              <!--                class="w-full px-4 py-2 placeholder-gray-400 border border-gray-300 rounded-full focus:outline-none h-[50px] focus:bg-[#5856D61A] focus:border-[#5856D6] focus:border-[0.5px] text-sm sm:text-base"-->
              <!--              />-->
              <!--              <button-->
              <!--                id="submitButton"-->
              <!--                class="w-full px-6 py-3 text-white bg-indigo-500 rounded-full cursor-not-allowed disabled:hover:bg-indigo-600 flex justify-center items-center gap-[10px] h-[50px] text-sm sm:text-base"-->
              <!--                @click="sendSmsMessage"-->
              <!--                :class="buttonActiveClass"-->
              <!--                :disabled="isPhoneNumberValid"-->
              <!--              >-->
              <!--                Davom etish-->
              <!--                <img-->
              <!--                  src="../assets/image/vector.png"-->
              <!--                  alt="Arrow"-->
              <!--                  class="h-3 w-3"-->
              <!--                />-->
              <!--              </button>-->
              <!--              <h1 class="flex items-center text-gray-500 text-xs sm:text-sm">-->
              <!--                <span class="flex-grow border-t border-gray-300"></span>-->
              <!--                <span class="px-3">Yoki bu servislar orqali</span>-->
              <!--                <span class="flex-grow border-t border-gray-300"></span>-->
              <!--              </h1>-->

              <!-- Social Login Buttons -->
              <div class="flex justify-center space-x-4 sm:space-x-6 w-full">
                <div
                  @click="googleNavigate"
                  class="flex items-center justify-center w-[4rem] h-[3rem] sm:w-[6rem] bg-white border border-gray-300 rounded-full cursor-pointer hover:border-[#5856D680] active:bg-[#5856D61A]"
                >
                  <img
                    src="../assets/image/google_icon.png"
                    alt="Google"
                    class="w-[1rem] h-[1rem]"
                  />
                </div>
                <div
                  class="flex items-center justify-center w-[4rem] h-[3rem] sm:w-[6rem] bg-white border border-gray-300 rounded-full opacity-50 pointer-events-none"
                >
                  <img
                    src="../assets/image/facebook_icon.png"
                    alt="Facebook"
                    class="w-[1rem] h-[1rem]"
                  />
                </div>
                <div
                  class="flex items-center justify-center w-[4rem] h-[3rem] sm:w-[6rem] bg-white border border-gray-300 rounded-full opacity-50 pointer-events-none"
                >
                  <img
                    src="../assets/image/apple_icon.png"
                    alt="Apple"
                    class="w-[1rem] h-[1rem]"
                  />
                </div>
              </div>

              <!--              <div class="p-2 sm:p-4">-->
              <!--                <div class="flex items-start">-->
              <!--                  <input-->
              <!--                    type="checkbox"-->
              <!--                    class="cursor-pointer mr-2 mt-1 flex-shrink-0"-->
              <!--                  />-->
              <!--                  <span-->
              <!--                    class="text-gray-500 text-[9px] sm:text-[10px] leading-relaxed"-->
              <!--                  >-->
              <!--                    Iltimos, xizmat ko'rsatish sifatini oshirish va-->
              <!--                    tajribangizni shaxsiylashtirish kabi ma'lum harakatlarni-->
              <!--                    amalga oshirish uchun ma'lumotlaringizni qayta ishlashga-->
              <!--                    ruxsat bering.-->
              <!--                  </span>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </div>

      <!-- Second Step - OTP Verification -->
      <div v-if="cardStep === 2" class="w-full max-w-[450px] mx-auto px-4">
        <div
          class="w-full bg-white rounded-lg shadow-lg p-4 sm:p-6 flex flex-col gap-4 sm:gap-6"
        >
          <!-- Back Button -->
          <div>
            <button
              class="flex gap-[10px] justify-start items-center text-sm sm:text-base"
              @click="backLogin"
            >
              <img
                src="../assets/image/vector-right.png"
                alt="vector-right"
                class="w-[0.5rem] h-3 sm:w-[0.5rem] sm:h-4"
              />
              <span>Ortga</span>
            </button>
          </div>

          <!-- Title and Description -->
          <div class="flex justify-center mt-[15px] flex-col">
            <span
              class="text-[24px] sm:text-[28px] text-[#090909] font-bold text-center"
            >
              Title
            </span>
            <span
              class="text-center block text-[14px] sm:text-[17px] mt-2 px-2 leading-relaxed"
            >
              Ro'yhatdan o'tish uchun,
              {{ phoneNumber.replace("(", "").slice(0, 7) }}
              <span class="text-gray-500">***</span>
              {{ phoneNumber.slice(13, 19) }} nomeriga 6 honali son yuborildi
            </span>
          </div>

          <!-- OTP Input Fields -->
          <div class="flex gap-[8px] sm:gap-[10px] justify-center">
            <div v-for="(code, index) in codes" :key="index">
              <input
                v-model="codes[index]"
                ref="otpInput"
                type="text"
                maxlength="1"
                class="w-[45px] h-[45px] sm:w-[60px] sm:h-12 text-center border rounded-full outline-none bg-[#5856D60D] border-[#5856D61A] text-lg font-medium"
                @input="moveFocus(index, index + 1)"
                @keydown="moveFocusBackspace(index, $event)"
                placeholder="-"
              />
            </div>
          </div>

          <!-- Submit Button -->
          <div>
            <button
              :class="buttonSendCodeClass"
              :disabled="isSendCodeValid"
              @click="sendCode"
              class="w-full px-6 py-3 text-white bg-indigo-500 rounded-full cursor-not-allowed disabled:hover:bg-indigo-600 flex justify-center items-center gap-[10px] h-[50px] text-sm sm:text-base"
            >
              Davom etish
            </button>
          </div>

          <!-- Timer and Resend -->
          <div class="flex justify-center gap-[5px] flex-wrap text-center">
            <span class="text-gray-700 text-[12px] sm:text-[13px]">{{
              formattedTime
            }}</span>
            <span class="text-[12px] sm:text-[13px]" :class="reSendCodeColer">
              Parolni qayta yuborish
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/http";
import { ElNotification } from "element-plus";

export default {
  data() {
    return {
      codes: ["", "", "", "", "", ""],
      phoneNumber: "",
      rawPhoneNumber: "",
      otpInput: null,
      isFocused: false,
      isPhoneNumberValid: true,
      cardStep: 1,
      isSendCodeValid: true,
      isReSendCodeValid: true,
      seconds: 0,
      minutes: 1,
    };
  },
  watch: {
    isReSendCodeValid(newValue) {
      this.isSendCodeValid = newValue === false;
    },
  },
  computed: {
    formattedTime() {
      return `${this.minutes < 10 ? "0" : ""}${this.minutes}:${
        this.seconds < 10 ? "0" : ""
      }${this.seconds}`;
    },
    inputBackgroundColor() {
      return this.phoneNumber
        ? "text-black font-black text-[13px] bg-[#5856D60F] border-[#5856D64D]"
        : "bg-white";
    },
    reSendCodeColer() {
      return this.isReSendCodeValid
        ? "text-gray-500"
        : "text-blue-500 cursor-pointer hover:underline";
    },
    buttonSendCodeClass() {
      return this.isSendCodeValid
        ? "opacity-50"
        : "cursor-pointer bg-[#5856D6] opacity-100";
    },
    buttonActiveClass() {
      return this.isPhoneNumberValid
        ? "opacity-50"
        : "cursor-pointer bg-[#5856D6] opacity-100";
    },
  },
  methods: {
    async getExtraData() {
      try {
        let response = await http.get("/auth/extra-data");
        localStorage.setItem("user_info", JSON.stringify(response.data));
        setTimeout(() => {
          this.$router.push("/main/users");
        }, 200);
      } catch (e) {
        if (e.response) {
          console.log(e.response);
        }
      }
    },
    startTimer() {
      const timer = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else if (this.minutes > 0) {
          this.minutes--;
          this.seconds = 59;
        }

        if (this.minutes === 0 && this.seconds === 0) {
          this.isReSendCodeValid = false;
          clearInterval(timer);
        } else {
          this.isReSendCodeValid = true;
        }
      }, 1000);
    },
    moveFocus(currentIndex, nextIndex) {
      if (
        this.codes[currentIndex].length >= 1 &&
        nextIndex < this.codes.length
      ) {
        this.$refs.otpInput[nextIndex].focus();
      }
      this.checkCodeLength();
    },
    moveFocusBackspace(currentIndex, event) {
      const key = event.key;
      if (
        key === "Backspace" &&
        currentIndex > 0 &&
        this.codes[currentIndex].length === 0
      ) {
        this.$refs.otpInput[currentIndex - 1].focus();
      } else if (
        key === "Backspace" &&
        currentIndex === 0 &&
        this.codes[currentIndex] === ""
      ) {
        event.preventDefault();
      }
      this.checkCodeLength();
    },
    backLogin() {
      this.cardStep = 1;
    },
    async sendSmsMessage() {
      try {
        let response = await http.post("/auth/send-sms", {
          phone: "+" + this.rawPhoneNumber,
        });
        const data = response.data;
        const status = data.status;
        if (status === true) {
          this.cardStep = 2;
          this.seconds = 0;
          this.minutes = 1;
          this.startTimer();
        } else {
          console.log("xatolik");
        }
      } catch (error) {
        ElNotification({
          message: "Serverda xatolik !",
          type: "error",
          showClose: true,
          position: "top-right",
        });
      }
    },
    async sendCode() {
      try {
        let response = await http.post("/auth/login", {
          phone: "+" + this.rawPhoneNumber,
          code: this.codes.join(""),
        });
        const data = response.data;
        const status = data.status;
        if (status === true) {
          localStorage.setItem("accessToken", data.token);
          localStorage.setItem("refreshToken", data.refreshToken);
          this.$router.push("/main/home");
        } else {
          console.log("xatolik");
        }
      } catch (error) {
        ElNotification({
          message: "Serverda xatolik !",
          type: "error",
          showClose: true,
          position: "top-right",
        });
      }
    },
    googleNavigate() {
      const clientId =
        "115536776507-5vt8qv662q7pc84skdk9ja9vkqsf28rn.apps.googleusercontent.com";
      const redirectUri = "https://snappy.uz/login/oauth2/code/google";
      const scope = "openid email profile";
      const responseType = "code";

      window.location.href = `https://accounts.google.com/o/oauth2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}`;
    },
    checkCodeLength() {
      let valid;
      valid = !this.codes.every((code) => code.length > 0);
      if (this.isReSendCodeValid === true) {
        this.isSendCodeValid = valid;
      } else {
        this.isSendCodeValid = true;
      }
    },
    handleKeydown(event) {
      if (event.key === "Backspace") {
        // Let the default backspace behavior happen
        // The formatPhoneNumber will be called afterward via v-model update
      }
    },
    formatPhoneNumber() {
      // Extract only digits from the input
      let digits = this.phoneNumber.replace(/\D/g, "");

      // Store raw number for API calls
      this.rawPhoneNumber = digits;

      // Handle the case when the backspace was used to delete the last digit
      if (digits.length === 0) {
        this.phoneNumber = "";
        this.isPhoneNumberValid = true;
        return;
      }

      // Ensure number starts with 998
      if (!digits.startsWith("998") && this.isFocused) {
        digits = "998" + digits;
      }

      // Format the phone number
      let formatted = "";
      if (digits.length > 0) formatted += "+" + digits.substring(0, 3);
      if (digits.length > 3) formatted += " (" + digits.substring(3, 5);
      if (digits.length > 5) formatted += ") " + digits.substring(5, 8);
      if (digits.length > 8) formatted += " " + digits.substring(8, 10);
      if (digits.length > 10) formatted += " " + digits.substring(10, 12);

      this.phoneNumber = formatted;

      // Update validation state
      this.isPhoneNumberValid = !(
        digits.length === 12 && digits.startsWith("998")
      );
    },
    onFocus() {
      this.isFocused = true;
      if (!this.phoneNumber) {
        this.phoneNumber = "+998";
      }
    },
    onBlur() {
      this.isFocused = false;
    },
  },
  mounted() {},
};
</script>
<style scoped>
.min-h-screen {
  background-image: url("../assets/image/login_page_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
